import {
    isArrayOrObject,
    isBoolean,
    isDate,
    isFile,
    isNull,
    isUndefined,
} from './helpers';

function getKey(key, parentKey) {
    return parentKey ? `${parentKey}[${key}]` : key;
}

/**
 * Формирует Массив параметров из объекта
 * @param {Object} data
 * @param {String} parentKey
 * @returns {Params}
 */
function getParams(data, parentKey = '') {
    const result = [];

    Object.entries(data).forEach(([key, value]) => {
        if (isArrayOrObject(value)) {
            result.push(...getParams(value, getKey(key, parentKey)));
        } else if (isBoolean(value)) {
            result.push([getKey(key, parentKey), encodeURIComponent(value ? 'Y' : 'N')]);
        } else if (isDate(value)) {
            result.push([getKey(key, parentKey), encodeURIComponent(value.toISOString())]);
        } else if (isFile(value)) {
            result.push([getKey(key, parentKey), value]);
        } else if (!isNull(value) && !isUndefined(value)) {
            result.push([getKey(key, parentKey), encodeURIComponent(value)]);
        }
    });

    return result;
}

/**
 * Формирует QueryString из объекта
 * @param {Object} data
 * @returns {String}
 */
export function queryString(data) {
    return `?${getParams(data)
        .map((arr) => arr.join('='))
        .join('&')}`;
}

/**
 * Формирует FormData из объекта
 * @param {Object} data
 * @returns {FormData}
 */
export function objectToFormData(data) {
    const params = getParams(data);
    const fd = new FormData();

    params.forEach(([key, value]) => {
        if (typeof value === 'string') {
            fd.append(`${key}`, decodeURIComponent(value));
        } else {
            fd.append(`${key}`, value);
        }
    });

    return fd;
}
